module.exports = __webpack_public_path__ + "img/qc_icon.89f5090.png";